import { PersonDataObject } from '@/components';
import { CellContextExtended } from '@/features/patientLists';
import { formatOptOutReason } from '@/features/reporting';

type CancelledPatientsOptOutReasonCellProps = {
	cellData: CellContextExtended;
	type?: string;
};

export const CancelledPatientsOptOutReasonCell = (
	props: CancelledPatientsOptOutReasonCellProps
) => {
	const { cellData } = props;
	const { opt_out_reason, opt_out_reason_other } = cellData.row.original as PersonDataObject;

	return (
		<>
			{formatOptOutReason(opt_out_reason)}
			{opt_out_reason_other ? `: ${opt_out_reason_other}` : ''}
		</>
	);
};
